"use client";

import { useId, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { webSiteNavigationLabels } from "../webSiteNavigation";
import { useWebMobileMenuOverlay } from "./useWebMobileMenuOverlay";
import { useCinematicWebRuntime } from "./useCinematicWebRuntime";

export function KineticMobileMenu({
    languageCode,
}: {
    languageCode?: string | null;
}) {
    const navigationId = useId();
    const sentinelRef = useRef<HTMLSpanElement>(null);
    const toggleRef = useRef<HTMLButtonElement>(null);
    const [isOpen, setIsOpen] = useState(false);
    const labels = webSiteNavigationLabels(languageCode);
    const header = useCinematicWebRuntime({
        headerScrolledAttribute: "data-kinetic-header-scrolled",
        revealedAttribute: "data-kinetic-revealed",
        revealAttribute: "data-kinetic-reveal",
        runtimeReadyAttribute: "data-kinetic-runtime-ready",
        sentinelRef,
        templateCode: "kinetic-club",
    });

    useWebMobileMenuOverlay({
        header,
        isOpen,
        navigationId,
        openAttribute: "data-kinetic-mobile-menu-open",
        setIsOpen,
        templateCode: "kinetic-club",
        toggleRef,
    });

    return (
        <>
            <span
                aria-hidden="true"
                data-kinetic-mobile-menu-runtime="true"
                ref={sentinelRef}
                style={{ display: "none" }}
            />
            {header
                ? createPortal(
                    <button
                        aria-controls={navigationId}
                        aria-expanded={isOpen}
                        aria-label={isOpen ? labels.closeMenu : labels.openMenu}
                        className="kinetic-mobile-menu-toggle"
                        onClick={(event) => {
                            event.stopPropagation();
                            setIsOpen((current) => !current);
                        }}
                        onPointerDown={(event) => event.stopPropagation()}
                        ref={toggleRef}
                        type="button"
                    >
                        <span />
                        <span />
                    </button>,
                    header,
                )
                : null}
        </>
    );
}
